import { put, takeLatest, call } from "redux-saga/effects";
import { fetchUserLatlngSuccess, fetchUserDetailsSuccess, fetchUserDetailsError } from "../actions/user.js";
import { FETCH_LATLNG, FETCH_USER_DETAILS } from "../actions/types";
import { fetchLatlng as fetchLatlngApi } from '../utils';
import { fetchUserDetails as fetchUserDetailsApi } from "../services/user";
import { showErrorMsg } from "../actions/snackbar";


function *fetchLatlng() {
  try {
    const position = yield call(fetchLatlngApi);
    // console.log(position);
    yield put(fetchUserLatlngSuccess(position.coords));
  } catch (error) {
    // console.error(error);
  }
}

function *fetchUserDetails(action) {
  try {
    const res = yield call(fetchUserDetailsApi, action.payload);
    const { name = '', email = ''} = res;
    yield put(fetchUserDetailsSuccess(name, email));
  } catch (error) {
    yield put(fetchUserDetailsError(error));
    yield put(showErrorMsg(error.message));
  }
}

export function* watchUser() {
  yield takeLatest(FETCH_LATLNG, fetchLatlng);
  yield takeLatest(FETCH_USER_DETAILS, fetchUserDetails);
}